import {QueryClient} from '@tanstack/react-query'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            networkMode: 'online',
            retry: 1,
            retryOnMount: true,
            retryDelay: 1000,
            staleTime: 600000, //10 min
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true
        }
    }
})

export const QUERY_KEYS = {
    MEASURES: 'measures',
    MEASURE_DETAILS: 'measure-details',
    SECTIONS: 'sections',
    HEADQUARTERS: 'headquarters',
    JUDICIAL_PANEL: 'judicial-panel',
    INVOLVED_PARTIES: 'involved-parties',
    MEASURE_TYPES: 'measure-types',
    MEASURE_SUB_TYPES: 'measure-sub-types',
    MEASURE_GENERAL_ROLE: 'measure-general-role'
} as const

export const MUTATION_KEYS = {} as const
